import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import type { NodeData } from "@/workflow_api/types/workflow";
import { Icon } from "@elaniintc/goes-design-system";
import { VariableKeyBox } from "../key-box";

interface Props {
  id: string;
}

const Content = ({ data }: { data: NodeData }) => {
  if (!data) {
    return (
      <Icon
        name="spinner-third"
        className="animate-spin text-sm text-on-disabled"
        type="far"
      />
    );
  }

  // Variables que genera el nodo de pago
  const paymentVariables = [
    { name: "resultado_pago", type: "boolean" },
    // { name: "id_transaccion", type: "string" },
    // { name: "monto_pagado", type: "number" },
    // { name: "metodo_pago", type: "string" },
    // { name: "fecha_pago", type: "date" },
    // { name: "estado_pago", type: "string" },
  ];

  return (
    <div className="flex">
      <div
        className={cn(
          "w-0.5 relative translate-x-[25px]",
          "bg-neutral-object-accent",
        )}
      >
        <span className="absolute left-3 top-3.5 w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] mb-4 w-full">
        <div className="py-1">
          <div className="space-y-3">
            {paymentVariables.map((variable) => (
              <VariableKeyBox
                key={variable.name}
                name={variable.name}
                type={variable.type as "string" | "number" | "date" | "boolean"}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const PaymentVariables = ({ id }: Props) => {
  const { getNodeById } = useWorkflowStore();
  const node = getNodeById(id);
  if (!node) return <></>;
  const nodeData = node.data as unknown as NodeData;
  return <Content data={nodeData} />;
};
